import React from "react";

export default function WhyChoose() {
  return (
    <section className="section light-section" id="why-choose-us">
      <div className="container">
        <div className="section-heading">
          <span className="section-label">Why Choose Yaich Translations</span>
          <h2>Professional, Clear and Client-Focused</h2>
          <p>
            The service is designed for clients who need trustworthy translation
            for important documents without unnecessary complexity.
          </p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <h3>Professional Human Translation</h3>
            <p>
              Every document is handled with professional human attention, not
              automated machine output.
            </p>
          </div>

          <div className="feature-card">
            <h3>Suitable for Important Documents</h3>
            <p>
              Ideal for legal, official, business, academic and administrative
              documentation.
            </p>
          </div>

          <div className="feature-card">
            <h3>Clear Communication</h3>
            <p>
              A straightforward and client-friendly process, from first contact
              to final delivery.
            </p>
          </div>

          <div className="feature-card">
            <h3>Confidential Handling</h3>
            <p>
              Sensitive documents are handled with care, discretion and
              professionalism.
            </p>
          </div>
        </div>

        <div className="document-types-box">
          <h3>Common Document Types</h3>
          <div className="document-tags">
            <span>Birth Certificates</span>
            <span>Marriage Certificates</span>
            <span>Contracts</span>
            <span>Court Documents</span>
            <span>Powers of Attorney</span>
            <span>Academic Certificates</span>
            <span>Administrative Letters</span>
            <span>Business Documents</span>
          </div>
        </div>
      </div>
    </section>
  );
}